import { delay, race, select, take } from 'redux-saga/effects'
import { IStoreState } from '../states'
import { UserInfoTypeKeys } from '../types'

/**
 * userInfo.town is only populated once checkSession's SET_USER_INFO lands.
 * Any saga reading it right after a fresh page load (before checkSession
 * resolves) would otherwise read the initial { id: 0 } and hit the API
 * with an invalid townId. Wait for it once, then read again.
 */
export function* selectUserTown(): any {
  let town = yield select((state: IStoreState) => state.userInfo.town)
  if (!town?.id) {
    yield race({
      userInfo: take(UserInfoTypeKeys.SET_USER_INFO),
      timeout: delay(8000)
    })
    town = yield select((state: IStoreState) => state.userInfo.town)
  }
  return town
}
